import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from '../../services/tenant.service';

@Component({
  selector: 'app-tenant-unavailable',
  standalone: false,
  templateUrl: './tenant-unavailable.component.html',
  styleUrl: './tenant-unavailable.component.scss',
})
export class TenantUnavailableComponent {
  loading = false;
  error = '';

  constructor(private router: Router, private tenant: TenantService) {}

  async retry() {
    this.loading = true;
    this.error = '';
    try {
      const cfg = await this.tenant.loadTenantConfig();
      // Service will navigate if we’re on /unavailable; this is a fallback:
      if (cfg) this.router.navigateByUrl('/menu');
    } catch (e: any) {
      this.error = e?.message || 'Still unavailable. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
